import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { Clock, Heart } from 'lucide-react';
export function OpeningHook() {
  return <AnimatedSection className="bg-cream" data-id="element-159">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-160">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-mint-light relative" data-id="element-161">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-mint text-white p-3 rounded-full shadow-md" data-id="element-162">
            <Clock className="w-6 h-6" data-id="element-163" />
          </div>

          <p className="text-xl md:text-2xl leading-relaxed text-charcoal font-medium italic text-center mt-4" data-id="element-164">
            "Son las 6:30 PM. El suelo está pegajoso, el ruido es insoportable y
            sientes ese calor familiar subiendo por tu cuello. Sabes lo que
            viene después. Estás a un segundo de explotar y decir algo que te
            pesará toda la noche mientras los miras dormir."
          </p>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-charcoal-light leading-relaxed px-4" data-id="element-165">
          <div className="flex items-start gap-4" data-id="element-166">
            <Heart className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-167" />
            <p data-id="element-168">
              <strong className="text-charcoal font-bold" data-id="element-169">
                No eres un mal padre.
              </strong>{' '}
              Estás operando con un sistema nervioso agotado que ha confundido
              el caos cotidiano con una amenaza de vida o muerte.
            </p>
          </div>
          <p className="pl-12" data-id="element-170">
            El amor por tus hijos es infinito, pero tu paciencia tiene un límite
            biológico.
          </p>
        </div>
      </div>
    </AnimatedSection>;
}